var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV5Velov2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 150,
    height: 150,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20.51 20.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-22.12 -22.31)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.04,
    y: 8.08,
    width: 55.92,
    height: 55.92
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.12,43.05H42.63V22.31H22.12ZM42.29,23.87V42.71H34.87c2.51-6.36,5-12.6,7.42-18.84M32.44,34.7c-1.49-4.2-2.86-8.05-4.29-12.05h8.52L32.44,34.7m-2.49,8H22.46V23.86L30,42.71",
    transform: "translate(-22.12 -22.31)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV5Velov2);
export default __webpack_public_path__ + "static/media/v5_velov_2.4d613b5e2a3f6c186330c392fec2948a.svg";
export { ForwardRef as ReactComponent };